import {sendRequest} from "./Sender";

export const AttendanceService = {
    GetList,
    GetCount,
    Update
}

function GetList(params= {}, expand = ''){
    return sendRequest('attendance/get-list', 'GET', {...params}, true)
}

function GetCount(params= []){
    return sendRequest('attendance/count', 'GET', {...params}, true)
}

function Update(data = []){
    return sendRequest('attendance/update', 'POST', {'attendance': data}, true)
}


